import { render } from "./CustomCard.vue?vue&type=template&id=ec988fac&ts=true"
import script from "./CustomCard.vue?vue&type=script&lang=ts"
export * from "./CustomCard.vue?vue&type=script&lang=ts"

import "./CustomCard.vue?vue&type=style&index=0&id=ec988fac&lang=scss"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__